import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Color } from '../../const'

export const Select = ({ options, value, name, width, height, onChange, onBlur, errorMessage, placeholder }) => (
  <Wrapper>
    <InputGroup>
      <SelectStyle width={width} height={height} name={name} value={value} onChange={onChange} onBlur={onBlur}>
        <option value='""'>{placeholder}</option>
        {options.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </SelectStyle>
      <Error>{errorMessage}</Error>
    </InputGroup>
  </Wrapper>
)

const Wrapper = styled.div`
  display: inline-flex;
  width: 100%;
  padding: 8px 0;
`
const InputGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`
const SelectStyle = styled.select(
  (props) => `
    padding: 15px 16px;
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    background: transparent!important;
    font-size: 16px;
    border: solid 1px ${Color.LINE.POWER_BLUE};
    border-radius: 5px;
    appearance: none;
  `
)
const Error = styled.div`
  color: ${Color.FONT.DANGER};
  text-align: left;
`

Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errorMessage: PropTypes.object,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
}
